import type { ParsedBusiness } from "~/data/.server/business";

export function AuthoritySection(props: {
  business: ParsedBusiness;
}) {
  const { carrierInfo, insurance } = props.business;

  const {
    commonAuthorityStatus,
    contractAuthorityStatus,
    brokerAuthorityStatus,
  } = carrierInfo?.detail ?? {};

  const authorityHistory = insurance?.authorityHistory ?? [];

  const pendingApplications = insurance?.pendingApplications ?? [];

  return (
    <>
      {/* Authority Status */}
      <div className="mb-6">
        <h3 className="mb-2 font-semibold">Authority Status</h3>
        <p>
          <span className="font-semibold">Common Authority Status:</span>{" "}
          {commonAuthorityStatus || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Contract Authority Status:</span>{" "}
          {contractAuthorityStatus || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Broker Authority Status:</span>{" "}
          {brokerAuthorityStatus || "N/A"}
        </p>
      </div>

      {/* Authority History */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h3 className="mb-2 font-semibold">Authority History</h3>
        {(authorityHistory?.length ?? 0 > 0) ? (
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-4 py-2">Action Type</th>
                <th className="border px-4 py-2">Original Action Date</th>
                <th className="border px-4 py-2">Disposition</th>
                <th className="border px-4 py-2">Disposition Date</th>
              </tr>
            </thead>
            <tbody>
              {authorityHistory?.map((entry, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">
                    {entry?.originalAction || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {entry?.originalActionDate || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {entry?.disposition || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {entry?.dispositionDate || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No authority history available.</p>
        )}
      </div>

      {/* Pending Applications */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h3 className="mb-2 font-semibold">Pending Applications</h3>
        {(pendingApplications?.length ?? 0 > 0) ? (
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-4 py-2">Authority Type</th>
                <th className="border px-4 py-2">Filed Date</th>
                <th className="border px-4 py-2">Status</th>
                <th className="border px-4 py-2">Insurance</th>
                <th className="border px-4 py-2">BOC-3</th>
              </tr>
            </thead>
            <tbody>
              {pendingApplications?.map((app, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">
                    {app?.auth_type || "N/A"}
                  </td>
                  <td className="border px-4 py-2">{app?.filed || "N/A"}</td>
                  <td className="border px-4 py-2">{app?.status || "N/A"}</td>
                  <td className="border px-4 py-2">
                    {app?.insurance || "N/A"}
                  </td>
                  <td className="border px-4 py-2">{app?.boc3 || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No pending applications available.</p>
        )}
      </div>
    </>
  );
}
